module.exports = __webpack_public_path__ + "static/img/Aziz-Behich.a5cf06f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Aziz-Behich.jpg
// module id = PcOo
// module chunks = 0